var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSelect',{attrs:{"options":_vm.landings,"v-model":_vm.model,"name":_vm.name,"label":_vm.label,"is-required":true,"target-property":_vm.targetProperty,"lib-options":{
    placeholder: _vm.placeholder,
    loading: _vm.loading,
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }